import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Catdry from './Catdry';
import Catwet from './Catwet';
import Header from '../inc/Header';


function CatFood() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />
          
               <ScrollToTop smooth top="100" color="maroon" />
            <div className="petprescriptionupload">
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Cat Food</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
              <br/>

            <div className="album py-0">
                <div className="container">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">DRY</button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">WET</button>

                        </div>
                    </nav>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                            <Catdry/>
                        </div>
                        <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <Catwet/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CatFood